'use strict'

const IdealPostcodes = require('ideal-postcodes-core');

export default {
    postcode: null,

    /**
     * Get the lookup client
     */
    client() {
        return new IdealPostcodes.Client({
            api_key: process.env.MIX_LOOKUP_POSTCODE_KEY
        })
    },
    /**
     * Lookup a postcode
     * @param {string} postcode
     * @param {*} callable
     */
    lookup(postcode, callable) {


        return this.client().lookupPostcode({
            postcode: postcode
        }, function (error, addresses) {
            callable(error, addresses)
        });
    },

    setPostcode(postcode) {
        this.postcode = postcode;
        return this;
    },

    /**
     * This formats a postcode to have a space so N16HT becomes N1 6HT etc
     * @param {string} postcode
     */
    format(postcode) {
        const regex = /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/;
        var parts = postcode.toUpperCase().match(regex);
        if (!parts) {
            return postcode;
        }
        parts.shift();
        return parts.join(' ');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Postcode.js